import React from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  CssBaseline,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  Dashboard as DashboardIcon,
  Group as GroupIcon,
  Category as CategoryIcon,
  AccountTree as AccountTreeIcon,
  AccountCircle as AccountCircleIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  Description as DescriptionIcon,
  ConfirmationNumber as ConfirmationNumberIcon,
} from "@mui/icons-material";
import { sideBarPages } from "../common/constant";

const menuItems = [
  { name: sideBarPages.DASHBOARD, path: "/dashboard", icon: <DashboardIcon /> },
  { name: sideBarPages.USERS, path: "/users", icon: <GroupIcon /> },
  {
    name: sideBarPages.CATEGORIES,
    path: "/categories",
    icon: <CategoryIcon />,
  },
  { name: sideBarPages.SERVICES, path: "/services", icon: <AccountTreeIcon /> },
  { name: sideBarPages.PROFILE, path: "/profile", icon: <AccountCircleIcon /> },
  {
    name: sideBarPages.WALLET,
    path: "/walletDetails",
    icon: <AccountBalanceWalletIcon />,
  },
  {
    name: sideBarPages.INVOICETEMPLATE,
    path: "/invoiceTemplate",
    icon: <DescriptionIcon />,
  },
  {
    name: "Get Promo Code",
    path: "/assign-promo-code",
    icon: <ConfirmationNumberIcon />,
  },
];

const AdminSidebar = ({ mobileOpen, handleDrawerToggle }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const drawerWidth = 280;

  const drawer = (
    <>
      <Toolbar />
      <List>
        {menuItems.map(({ name, path, icon }, index) => (
          <ListItem button key={index} sx={{ color: "aliceblue" }}>
            <ListItemIcon sx={{ color: "inherit" }}>{icon}</ListItemIcon>
            <ListItemText
              primary={
                <Typography
                  variant="h6"
                  sx={{
                    cursor: "pointer",
                    fontSize: { xs: "14px", md: "16px" },
                  }}
                >
                  <Link
                    to={path}
                    style={{
                      textDecoration: "none",
                      color: "inherit",
                    }}
                    onClick={() => isMobile && handleDrawerToggle()}
                  >
                    {name}
                  </Link>
                </Typography>
              }
            />
          </ListItem>
        ))}
      </List>
    </>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      {isMobile ? (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              background: "linear-gradient(90deg, #20164F, #20164F)",
            },
          }}
        >
          {drawer}
        </Drawer>
      ) : (
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              background: "linear-gradient(90deg, #20164F, #20164F)",
            },
          }}
          variant="permanent"
          anchor="left"
        >
          {drawer}
        </Drawer>
      )}
    </Box>
  );
};

export default AdminSidebar;
